import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import DateAndTimePickerPost from '../../Form/DateAndTimePickerPost';

const SchedulePostConfig = ({
  scheduledPublishDate,
  setScheduledPublishDate,
  closeModal,
  saveScheduledPublishDate,
}) => {
  const [isLoading, setLoading] = useState(true);

  const schedule = () => {
    saveScheduledPublishDate();
    closeModal();
  };

  // const cancelSchedule = () => {
  //   setScheduledPublishDate(null);
  //   saveScheduledPublishDate();
  //   closeModal();
  // };

  const handleDate = (name, value) => {
    setScheduledPublishDate(value);
  };

  const resetDate = () => {
    setScheduledPublishDate(null);
  };

  useEffect(() => {
    setLoading(false);
  }, [scheduledPublishDate]);

  return (
    <>
      {!isLoading ? (
        <div className="post-config">
          <div className="bg-greyFilter px-4 flex justify-between items-center rounded-t-lg px-7 h-12">
            <span className="font-americaMonoBold text-sm uppercase text-black">Schedule post publish date</span>
          </div>
          <div className="w-full flex -my-5">
            <DateAndTimePickerPost action="edit" title="" name="date" handleDate={handleDate} existingDate={scheduledPublishDate} className="text-center mx-0 xxl:text-left xxl:text-xs h-36px" isConfig reset={resetDate} wFull />
          </div>

          <div className="flex justify-end my-2">
            <button type="button" className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" onClick={() => closeModal()}>
              Cancel
            </button>
            <button onClick={schedule} className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" type="button">
              Save
            </button>
          </div>

        </div>
      ) : null}
    </>
  );
};

SchedulePostConfig.propTypes = {
  scheduledPublishDate: PropTypes.string,
  setScheduledPublishDate: PropTypes.func.isRequired,
  saveScheduledPublishDate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

SchedulePostConfig.defaultProps = {
  scheduledPublishDate: null,
};

export default withRouter(SchedulePostConfig);
